// Links to Backbone Help Center
export enum HelpCenterLinks {
  EN = 'https://help.bkbn.com/s/?language=en_US',
  FR = 'https://help.bkbn.com/s/?language=fr',
  DE = 'https://help.bkbn.com/s/?language=de',
}
